import { FunctionComponent } from "react";
import { Text } from "@kanda-libs/ks-design-library";
import usePaymentInfoProps from "components/payment/PaymentInfo/usePaymentInfoProps";
import { SKELETONS } from "components/payment/PaymentInfo/constants";
import { useSelector } from "react-redux";
import { selectors } from "store";

const PaymentInfo: FunctionComponent = () => {
  const { updatedAt, createdAt } = usePaymentInfoProps();
  const isLoading = useSelector(selectors.getIsLoading);

  return (
    <div className="flex flex-col mb-6">
      <Text
        text="Payment timeline:"
        className="mb-6 text-16-20-em text-neutral-800"
        isLoading={isLoading}
        skeletonProps={SKELETONS.title}
      />
      <div className="flex flex-row mb-1">
        <Text
          text="Created:"
          className="mr-2 text-14-22-em text-neutral-800 min-w-20"
          isLoading={isLoading}
        />
        <Text
          text={`${createdAt?.time} on ${createdAt?.date}`}
          className="text-14-22 text-neutral-800"
          isLoading={isLoading}
        />
      </div>
      <div className="flex flex-row">
        <Text
          text="Updated:"
          className="mr-2 text-14-22-em text-neutral-800 min-w-20"
          isLoading={isLoading}
        />
        <Text
          text={`${updatedAt?.time} on ${updatedAt?.date}`}
          className="text-14-22 text-neutral-800"
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default PaymentInfo;
